import qs from 'qs';

const Level = {
    namespaced: true, 
    state: {
        levelData: [], 
    },

    getters: {
        levelData(state) {
            return state.levelData;
        },
    },

    mutations: {

        /**
         * Установить значение объекта
         * @param state
         * @param items
         */
        setArr(state, { items }) {
            state['levelData'] = items;
        },

        /**
         * Обновить значение элемента объекта
         * @param state
         * @param item
         * @param index
         */
        setItem(state, { item, index }) {
            state['levelData'][index] = item;
        },

        /**
         * Добавить значение элемента объекта
         * @param state
         * @param item
         */
        addItem(state, { item }) {
            state['levelData'].push(item);
        },

        /**
         * Удалить элемент из объекта
         * @param state
         * @param item
         */
        remove(state, { item }) {
            state['levelData'] = state['levelData'].filter(iItem => iItem !== item);
        },
    },


    actions: {

        /**
         * Получение данных по уровням
         * @param commit
         * @param dispatch
         * @param getters
         * @param rootGetters
         * @returns {Promise<any>}
         */
        getLevelData({ commit, dispatch, getters, rootGetters }) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, { root: true });
                axios({
                    url: rootGetters.rootUrl + 'list/index',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'token': this.getters['auth/getToken'],
                        'service': rootGetters.service.level
                    }),
                }).then(response => (
                    commit('setArr', {
                        items: response.data
                    }),
                    dispatch('loading/isLoading', false, { root: true }),
                    window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Данные по уровням доступа получены.'),
                    resolve()
                )).catch(err => {
                    dispatch('loading/isLoading', false, { root: true }),
                        console.log('ERROR IN level.js | getLevelData : ' + err);
                    window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка в получении данных по уровням доступа!'),
                        reject(err);
                });
            })
        },

        /**
         * Сохранение данных по уровням
         * @param commit
         * @param data
         * @returns {Promise<any>}
         */
        saveLevelData({ commit, dispatch, getters, rootGetters}, data) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, { root: true });
                const str = JSON.stringify(data.data);
                axios({
                    url: rootGetters.rootUrl + 'list/save',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'data': str,
                        'token': this.getters['auth/getToken'],
                        'service': rootGetters.service.level
                    }),
                }).then(response => {
                    console.log(response.data);
                    // Если редактирование
                    if (data.index !== -1) {
                        commit('setItem', {
                            item: data.data,
                            index: data.index
                        });
                        dispatch('loading/isLoading', false, { root: true });
                        window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Данные по уровням успешно отредактированы!');

                        // Если сохранение нового
                    } else {
                        data.data.levelId = response.data[0].levelId;
                        commit('addItem', {
                            item: data.data
                        });
                        dispatch('loading/isLoading', false, { root: true });
                        window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Новый уровень успешно создан!');
                    }
                    resolve();
                }).catch(err => {
                    dispatch('loading/isLoading', false, { root: true });
                    window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при сохранении данных!');
                    console.log('ERROR IN level.js | saveLevelData : ' + err);
                    reject(err);
                });
            })
        },

        /**
         * Удаление уровня
         * @param commit
         * @param data
         * @returns {Promise<any>}
         */
        removeLevelData({ commit, dispatch, getters, rootGetters }, data) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, { root: true });
                const str = JSON.stringify(data.item);
                axios({
                    url: rootGetters.rootUrl + 'list/delete',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'data': str,
                        'token': this.getters['auth/getToken'],
                        'service': rootGetters.service.level,
                    }),
                }).then(response => (
                    commit('remove', {
                        item: data.item
                    }),
                    dispatch('loading/isLoading', false, { root: true }),
                    window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Уровни успешно удалены!'),
                    resolve()
                )).catch(err => {
                    dispatch('loading/isLoading', false, { root: true });
                    window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при удалении уровня!'),
                        console.log('ERROR IN level.js | removeLevelData : ' + err);
                    reject(err);
                });
            })
        },
    },
};

export default Level;





// WEBPACK FOOTER //
// ./src/store/modules/level.js